const images = [
    '/img/boardPhoto/icon-1.png',
    '/img/boardPhoto/icon-2.png',
    '/img/boardPhoto/icon-3.png',
    '/img/boardPhoto/icon-4.png',
    '/img/boardPhoto/icon-5.png',
    '/img/boardPhoto/icon-6.png',
    '/img/boardPhoto/icon-7.png',
    '/img/boardPhoto/icon-8.png',
    '/img/boardPhoto/icon-9.png',
    '/img/boardPhoto/icon-10.png',
    '/img/boardPhoto/icon-11.png',
    '/img/boardPhoto/icon-12.png',
    '/img/boardPhoto/icon-13.png',
    '/img/boardPhoto/icon-14.png',
    '/img/boardPhoto/icon-15.png',
    '/img/boardPhoto/icon-16.png'
]
export default images;